angular.module('boyds', ['ngProgress', 'ui.bootstrap', 'ngSanitize', '720kb.socialshare', 'ngToast', 'ngAnimate']);